import React from "react";
import TransformToolPrep from "../../shared/Popup/TransformToolPrep";

const RotateToolPrep = (props) => (
  <TransformToolPrep mode="rotate" {...props} />
);

export default RotateToolPrep;
